import styled from '@emotion/styled';

const FileIconWrapper = styled('figure')({
  margin: 0,
  width: 24,
  height: 20,
  '> svg': {
    maxHeight: '100%',
  },
});

export default FileIconWrapper;
